import {
  type FetchInventoryItemExportsFn,
  type FetchInventoryItemsByIdsFn,
  type ImportInventoryItemsFn,
  type ListInventoryItemsForProviderFn,
  type InventoryFeatureOptions,
  type ListInventoryItemsFn,
} from '@/features/inventory'
import type { PrimeDocumentTypeByShortIdFn } from '@/features/documents'
import { InventoryApi } from '@/features/inventory/api/inventory-api'
import { InventoryManagerViewModel } from '@/features/inventory/admin/InventoryManagerViewModel'
import { env } from '@/infra/env'
import { FilterStorage } from '@/infra/FiltersViewModel'
import { localStorage } from '@/infra/storage'
import { InventoryStore } from './InventoryStore'

export function InternalInventoryFeature(
  options: InventoryFeatureOptions,
  primeDocumentTypeByShortId: PrimeDocumentTypeByShortIdFn,
) {
  const api = new InventoryApi({
    baseURL: env.WORK_DOTNET_API,
    token$: options.token$,
  })

  const inventoryStore = new InventoryStore(
    api,
    options.primeWorkspace,
    options.primeUser,
    primeDocumentTypeByShortId,
  )

  const listInventoryItems: ListInventoryItemsFn = (query, signal) =>
    inventoryStore.listInventoryItems(query, signal)

  const listInventoryItemsForProvider: ListInventoryItemsForProviderFn = (
    query,
    signal,
  ) => inventoryStore.listInventoryItemsForProvider(query, signal)

  const fetchInventoryItemsByIds: FetchInventoryItemsByIdsFn = (
    ids,
    workspaceId,
    signal,
  ) => inventoryStore.fetchInventoryItemsByIds(ids, workspaceId, signal)

  const fetchInventoryItemExports: FetchInventoryItemExportsFn = (
    ids,
    workspaceId,
    signal,
  ) => inventoryStore.fetchInventoryItemExports(ids, workspaceId, signal)

  const importInventoryItems: ImportInventoryItemsFn = (items, workspaceId) =>
    inventoryStore.importInventoryItems(items, workspaceId)

  const inventoryManagerViewModel = new InventoryManagerViewModel(
    options.newAlert,
    options.createAlertErrorHandler,
    options.createAlertRetryWrapper,
    inventoryStore,
    options.getCurrentUserWorkspaceMemberships,
    (ns) => new FilterStorage(localStorage, ns),
    options.fetchDocumentTypes,
  )

  return {
    // Internal
    listInventoryItems,
    listInventoryItemsForProvider,
    fetchInventoryItemsByIds,
    fetchInventoryItemExports,
    importInventoryItems,
    inventoryManagerViewModel,
  }
}
